module.exports = __webpack_public_path__ + "static/media/bed.0c29a041.svg";